import React from "react";

export const Header = (props) => {
  return (
    <header id="header" style={{
      maxWidth: "100%",
      overflow: "hidden",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    }}>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 style={{fontSize: 70}}>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p style={{fontSize: 20}}>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Leggi di più
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
